import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'shorten'
})
export class ShortenPipe implements PipeTransform{
    transform(val:string, chars:number = 150){
        if(val && (val.length > chars)) {
            return val.substring(0, chars) + '...';
        } else {
            return val;
        }  
    }
}